import React from "react";
//#region types
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { CommonEnums } from "models/enums";
//#endregion
//#region components
import { Dialog, Grid } from "@mui/material";
import { ErrorBoundary } from "components/error";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const SimpleDialog: React.FC<DialogProps> = (props) => {
  const onClose = () => {
    const closeHandler = () => {
      props.onClose && props.onClose();
      props.closeDialog && props.closeDialog();
    };

    if (props.overrideCloseMenu) {
      props.overrideCloseMenu(closeHandler);
    } else {
      closeHandler();
    }
  };

  return (
    <Dialog
      aria-labelledby="dialog-title"
      open={props.isOpen}
      maxWidth={props.maxWidth ?? "sm"}
      hideBackdrop={false}
      classes={{
        paper: clsx(cssExports.simpleDialogRoot, props.className),
      }}
      onClose={onClose}
    >
      <Grid container justifyContent="center" alignItems="center">
        <ErrorBoundary subComponentType={CommonEnums.SubComponentType.Dialog}>
          {props.children as React.ReactNode}
        </ErrorBoundary>
      </Grid>
    </Dialog>
  );
};

export default SimpleDialog;
